module.exports = __webpack_public_path__ + "public/images/food.94ec6cd58b41ed2317e4ca72e7a88c34.png";